import { render } from "./FilterAndKeywordPanel.vue?vue&type=template&id=a23220c0"
import script from "./FilterAndKeywordPanel.vue?vue&type=script&lang=js"
export * from "./FilterAndKeywordPanel.vue?vue&type=script&lang=js"

import "./FilterAndKeywordPanel.vue?vue&type=style&index=0&id=a23220c0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__